import { Controller } from "@hotwired/stimulus"

// Floating support chat. Sends messages to /support_chat and renders replies.
// Keeps a short local history for context; escalation link is always visible.
export default class extends Controller {
  static targets = ["panel", "messages", "input", "send"]
  static values = { url: String }

  connect() { this.history = [] }

  toggle() { this.panelTarget.classList.toggle("hidden") }
  close() { this.panelTarget.classList.add("hidden") }

  keydown(event) {
    if (event.key === "Enter" && !event.shiftKey) { event.preventDefault(); this.submit() }
  }

  async submit() {
    const text = this.inputTarget.value.trim()
    if (!text || this.busy) return
    this.inputTarget.value = ""
    this.append("user", text)
    this.busy = true
    this.sendTarget.disabled = true
    const typing = this.append("assistant", "…", true)

    try {
      const token = document.querySelector('meta[name="csrf-token"]')?.content
      const res = await fetch(this.urlValue, {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-CSRF-Token": token || "" },
        body: JSON.stringify({ message: text, history: this.history })
      })
      const data = await res.json()
      typing.classList.remove("animate-pulse")
      typing.textContent = data.reply
      this.history.push({ role: "user", content: text })
      this.history.push({ role: "assistant", content: data.reply })
      this.history = this.history.slice(-10)
    } catch {
      typing.classList.remove("animate-pulse")
      typing.textContent = this.element.dataset.errorText || "Une erreur est survenue."
    } finally {
      this.busy = false
      this.sendTarget.disabled = false
      this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight
      this.inputTarget.focus()
    }
  }

  append(role, text, pending = false) {
    const bubble = document.createElement("div")
    bubble.className = role === "user"
      ? "ml-auto max-w-[85%] whitespace-pre-line rounded-2xl rounded-br-sm bg-brand-600 px-3 py-2 text-sm text-white"
      : "mr-auto max-w-[85%] whitespace-pre-line rounded-2xl rounded-bl-sm bg-gray-100 px-3 py-2 text-sm text-gray-800"
    bubble.textContent = text
    if (pending) bubble.classList.add("animate-pulse")
    this.messagesTarget.appendChild(bubble)
    this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight
    return bubble
  }
}
